import { Element } from "../Element";
import { ElementInterface } from "../interfaces/ElementInterface";
import { ExhibitionModelInterface } from "../interfaces/exhibition/ExhibitionModelInterface";
import { SessionOnlineParams } from "../interfaces/session/OnlineParams";

export class ExhibitionModel extends Element implements ExhibitionModelInterface  {

    parentId?: string;
    title?: string;
    subtitle?: string;
    groupTitle?: string;
    imageFileId?: string;
    iconFileId?: string;
    orderIndex?: number;
    description?: string;
    webClientDescription?: string;
    childrenViewType?: string;
    tagsIds?: string[];
    userProfileIds?: string[];
    groupIds?: string[];
    deeplink?: string;
    widgetParams?: object;
    isOnline?: boolean;
    onlineParams?: SessionOnlineParams;
    eventId?: string;
    fileIds?: string[];
    links?: object;
    bannerFileId?: string;
    isMain?: boolean;
    needContactsAgreement?: boolean;

    constructor(data: ElementInterface, schema = "") {
        super(data, schema, []);
    }
}